import { render, staticRenderFns } from "./CreateContactChoiceModal.vue?vue&type=template&id=2f72fea6&scoped=true&lang=pug"
import script from "./CreateContactChoiceModal.vue?vue&type=script&lang=js"
export * from "./CreateContactChoiceModal.vue?vue&type=script&lang=js"
import style0 from "./CreateContactChoiceModal.vue?vue&type=style&index=0&id=2f72fea6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f72fea6",
  null
  
)

export default component.exports